"use client"

import * as React from "react"
import { SearchIcon } from "lucide-react"
import { cn } from "@/lib/utils"

interface LocationSearchButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  placeholder: string
  size?: "default" | "lg"
  "aria-expanded"?: boolean
}

export const LocationSearchButton = React.forwardRef<
  HTMLButtonElement,
  LocationSearchButtonProps
>(function LocationSearchButton(
  { placeholder, size = "default", className, "aria-expanded": ariaExpanded = false, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      role="combobox"
      aria-controls="location-search-listbox"
      aria-expanded={ariaExpanded}
      aria-label={placeholder}
      className={cn(
        "flex w-full items-center gap-2 rounded-md border border-input bg-background text-muted-foreground shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        size === "lg" ? "h-14 px-5 text-lg" : "h-10 px-3 text-sm",
        className
      )}
      {...props}
    >
      <SearchIcon
        className={cn(
          "shrink-0 opacity-50",
          size === "lg" ? "size-5" : "size-4"
        )}
      />
      <span className="truncate">{placeholder}</span>
    </button>
  )
})
